import { FC, SyntheticEvent, useEffect, useState } from "react";
import { useParams } from "next/navigation";
import { AssetsDirectory, Language } from "@finbackoffice/enums";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Svg } from "../svg/Svg";
import styles from "./date-range-picker.module.sass";
import { resolveLocale } from "./locale-resolver";

export type DateRangePickerReturnObj = {
    from: Date;
    to: Date;
};

interface IProps {
    range: any;
    onChange: (data: DateRangePickerReturnObj) => void;
    dateFormat?: string;
    onInnerIconClick?: (e: SyntheticEvent) => void;
}

const DateRangePicker: FC<IProps> = ({ range, onChange, dateFormat, onInnerIconClick }) => {
    const { lang: locale } = useParams();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        async function loadLocale() {
            if (!locale) return;
            const content = await resolveLocale(locale as Language);
            registerLocale(locale as string, content);
            setLoaded(true);
        }

        void loadLocale();
    }, [locale]);

    if (!loaded) {
        return;
    }

    return (
        <div className={styles.dateRangePickerContainer}>
            <DatePicker
                startDate={range?.from}
                endDate={range?.to}
                dateFormat={dateFormat}
                onChange={(data: any) => onChange({ from: data[0], to: data[1] })}
                monthsShown={1}
                selectsRange
                locale={locale as string}
                wrapperClassName={styles.dateRangePicker}
                calendarClassName={styles.dateRangePickerContent}
            />
            <Svg
                src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/calendar.svg`}
                onClick={onInnerIconClick}
                className={styles.calendarIcon}
            />
        </div>
    );
};

export default DateRangePicker;
